// extracted by mini-css-extract-plugin
module.exports = {"center":"MainMenu_center__CYW1m","container":"MainMenu_container__3biXh","logo":"MainMenu_logo__eX_Hb","nav":"MainMenu_nav__dQSEY","navItem":"MainMenu_navItem__RsdDB"};